import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ roles }) => {
  const authLocalstorageStr = sessionStorage.getItem('authLocalstorage');
  
  // If there's no auth data in session storage, redirect to the login page
  if (!authLocalstorageStr) {
    console.log('🔒 No auth data in session storage');
    return <Navigate to="/" replace />;
  }
  
  try {
    const authLocalstorage = JSON.parse(authLocalstorageStr);
    
    // If there's no token in the auth data, redirect to the login page
    if (!authLocalstorage || !authLocalstorage.token) {
      console.log('🔒 No token in auth data');
      return <Navigate to="/" replace />;
    }
    
    // Debug: Log the auth data
    console.log('🔍 Auth data:', {
      user: authLocalstorage.user?.name,
      role: authLocalstorage.role,
      roles: authLocalstorage.roles,
      requiredRoles: roles
    });
    
    // Check if roles array exists, if not, try to create it from role ID
    let userRoles = authLocalstorage.roles;
    if (!userRoles || !Array.isArray(userRoles) || userRoles.length === 0) {
      console.log('⚠️ No roles array, creating from role ID');
      const roleId = authLocalstorage.role;
      if (roleId === 1) userRoles = ['admin', 'user'];
      else if (roleId === 2) userRoles = ['user'];
      else if (roleId === 3) userRoles = ['admin', 'user', 'super_admin'];
      else if (roleId === 4) userRoles = ['user-facture'];
      else if (roleId === 5) userRoles = ['client'];
      else {
        console.warn('⚠️ Unknown role ID:', roleId, '- defaulting to user');
        userRoles = ['user']; // Default fallback
      }
      
      // Update the session storage with the correct roles
      const updatedAuthState = { ...authLocalstorage, roles: userRoles };
      sessionStorage.setItem('authLocalstorage', JSON.stringify(updatedAuthState));
    }

    // Check if the user's role is in the provided roles
    const hasAccess = roles && roles.length > 0 && roles.some(role => userRoles.includes(role));
    
    console.log('🔍 Access check:', {
      userRoles,
      requiredRoles: roles,
      hasAccess
    });

    // If the user doesn't have access to any of the roles, redirect to NotAuthorized page
    if (!hasAccess) {
      console.log('🚫 Access denied');
      return <Navigate to="/NotAuthorized" replace />;
    }

    console.log('✅ Access granted');
    // If authorized, render the children route
    return <Outlet />;
  } catch (error) {
    console.error('❌ Error parsing authentication data:', error);
    // If there's an error parsing the auth data, redirect to the login page
    sessionStorage.removeItem('authLocalstorage');
    return <Navigate to="/" replace />;
  }
};

export default ProtectedRoute;
